import React from "react";
import { FaFacebookSquare, FaLinkedin, FaTwitterSquare } from "react-icons/fa";
import FooterLogo from "../assets/logos/alpaca_white.svg";
import DynamicsLogo from "../assets/logos/dymanics.svg";
import PhoneIcon from "../assets/graphics/phone.svg";
import MailIcon from "../assets/graphics/mail.svg";
import MapIcon from "../assets/graphics/map.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-item">
        <div>
          <div className="footer-row">
            <img className="footer-logo" src={FooterLogo} alt="Alpaca Logo" />
          </div>
          <p className="small-text left white">
            Alpaca leverages 35 years of manufacturing, implementation and
            software experience to redefine ERP program implementation and help
            customers discover opportunities.
          </p>
          <p className="storyset">
            Some illustrations are provided by
            <a
              className="storyset-link"
              href="https://storyset.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              storyset.com
            </a>
          </p>
        </div>
      </div>
      <div className="footer-item" style={{ paddingLeft: "20px" }}>
        <div className="footer-row">
          <img className="footer-icon" src={PhoneIcon} alt="Phone Icon" />
          <a href="tel:4034648956">
            <p className="small-text white">403-464-8956</p>
          </a>
        </div>
        <div className="footer-row">
          <img className="footer-icon" src={MailIcon} alt="Mail Icon" />
          <a href="mailto:sales@alpacasys.com">
            <p className="small-text white">sales@alpacasys.com</p>
          </a>
        </div>
        <div className="footer-row">
          <img className="footer-icon" src={MapIcon} alt="Map Icon" />
          <a
            href="https://www.google.com/maps/place/Alpaca+Systems/@51.0918588,-113.9996818,15z/data=!4m2!3m1!1s0x0:0x74bc1845567bc992?sa=X&ved=2ahUKEwir6oiUqsv2AhUNGDQIHUfuDEkQ_BJ6BAgrEAU"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p className="small-text white">
              2618 Hopewell Pl NE, Unit 210
              <br />
              Calgary, AB
            </p>
          </a>
        </div>
      </div>
      <div className="footer-item">
        <img className="dynamics-logo" src={DynamicsLogo} alt="Dynamics Logo" />
      </div>
      <div className="footer-item">
        <div>
          <a
            href="https://www.facebook.com/AlpacaSystems/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookSquare id="fb" />
          </a>
          <a
            href="https://www.linkedin.com/company/78391201/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin id="lk" />
          </a>
          <a
            href="https://twitter.com/AlpacaSystems"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitterSquare id="twitter" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
